export default {
      id: "nominee-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#nominee",
      toString: function () {
        return this.url;
      }
    }